import React, { useState, useEffect } from "react";
import useStyles from "../styles";
import { useLocation, useHistory } from "react-router-dom";
import config from "../../../config";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import InputComponent from "../../partner/components/inputComponent";
import InputSelect from "../../partner/components/inputSelect";
import InputDisable from "../../partner/components/inputDisable";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { CircularProgress } from "@material-ui/core";
import InputDisableSimpleText from "../../user/components/inputDisableSimpleText";
import { Edit, Delete } from "@material-ui/icons";
import Modal from "../../modals/Modal";
import SelectServicesAndDays from "./selectServiceAndDays";
import InputDecimal from "../../partner/components/inputDecimal";

export default function MembershipInfo() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{4,500}$/, // Letras
        textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
    }

    const classes = useStyles();
    const location = useLocation();
    let history = useHistory();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [membershipName, setMembershipName] = useState({ text: '', valid: null });
    const [description, setDescription] = useState({ text: '', valid: null });
    const [services, setServices] = useState({ text: [], valid: null, cost: '' });
    const [servicesCost, setServicesCost] = useState({ text: '', valid: null });
    const [membershipType, setMembershipType] = useState({ text: '', valid: null });
    const [membershipValidity, setMembershipValidity] = useState('Vigencia');
    const [initTime, setInitTime] = useState('00:00');
    const [closeTime, setCloseTime] = useState('00:00');
    const [membershipStatus, setMembershipStatus] = useState({ text: '', valid: null });
    const [creationDate, setCreationDate] = useState('');
    const [lastUpdateDate, setLastUpdateDate] = useState('');
    const [isOutOfDate, setIsOutOfDate] = useState(true);
    const [servicesAndDays, setServicesAndDays] = useState(null);
    const [selectServicesKey, setSelectServicesKey] = useState(0);
    const [keyTable, setKeyTable] = useState(0);

    const [membershipInfo, setMembershipInfo] = useState([]);
    const [allServices, setAllServices] = useState([]);
    const [allMembershipType, setAllMembserhipType] = useState([]);
    const [allStatus, setAllStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingToSaveMembership, setIsLoadingToSaveMembership] = useState(false);
    const [disableInpunts, setDisableInpunts] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250
            }
        },
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "center"
        },
        variant: "menu"
    };

    const fetchMembershipInfo = async () => {
        var id = '';

        try {
            if (location.state.id == null) {
                id = location.state.id;
            } else {
                id = localStorage.getItem('membershipInfo');
            }
        } catch (e) {
            id = localStorage.getItem('membershipInfo');
        }

        fetch(baseUrl + "membershipById/" + id,
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data != null) {
                    setMembershipInfo(data);
                    setMembershipName({ text: data.membershipName, valid: 'true' });
                    setDescription({ text: data.description, valid: 'true' });
                    setMembershipType({ text: data.membershipType, valid: 'true' });
                    setMembershipValidity(data.membershipValidity);
                    setInitTime(data.initTime);
                    setCloseTime(data.closeTime);
                    setMembershipStatus({ text: data.status, valid: 'true' });
                    setCreationDate(data.creationDate);
                    setLastUpdateDate(data.lastUpdateDate);
                    setServicesCost({ text: data.cost, valid: 'true' });
                    const servicesList = [];

                    data.services.map((option) => {
                        var servicesItem = {
                            "serviceName": option.serviceName,
                            "numberOfDays": option.numberOfDays,
                        };

                        servicesList.push(servicesItem);
                    });
                    setServices({ text: servicesList, valid: 'true' });
                    setServicesAndDays(servicesList);
                    setIsOutOfDate(data.isOutOfDate == 1 ? true : false);
                } else {
                    setShowModal(true);
                }
                setIsLoading(false);
            })
            .catch(error => null);
    }

    const fetchStatus = async () => {
        if (!showModal) {
            fetch(baseUrl + "genericStatus",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllStatus(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchServices = async () => {
        if (!showModal) {
            fetch(baseUrl + "services",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllServices(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchMembershipType = async () => {
        if (!showModal) {
            fetch(baseUrl + "membershipType",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllMembserhipType(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    useEffect(() => {
        fetchMembershipInfo();
        fetchStatus();
        fetchServices();
        fetchMembershipType();
    }, [location]);

    const handleChange = (e) => {
        const value = e.target.value;

        if (value != '') {
            setMembershipType({ text: value, valid: 'true' });
            allMembershipType.map((item) => {
                if (item.name == value) {
                    setMembershipValidity(item.validity);
                }
            });
        } else {
            setMembershipType({ text: value, valid: 'false' });
            setMembershipValidity('Vigencia');
        }
    }

    const handleInitTimeChange = (event) => {
        setInitTime(event.target.value);
    };

    const handleCloseTimeChange = (event) => {
        setCloseTime(event.target.value);
    };

    const valuesFromServicesComponent = (values) => {
        setServicesAndDays(values);
    }

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoadingToSaveMembership(true);

        const newMembership = {
            id: membershipInfo.id, membershipName: membershipName.text, description: description.text,
            services: servicesAndDays, membershipType: membershipType.text, membershipValidity: membershipValidity,
            accessCount: membershipValidity, cost: servicesCost.text, status: membershipStatus.text,
            initTime: initTime, closeTime: closeTime, isOutOfDate: isOutOfDate == true ? 1 : 0
        };

        const response = await fetch(baseUrl + "updateMembership/", {
            method: 'PUT',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
            body: JSON.stringify(newMembership)
        });

        const json = await response.json();
        if (json.message == "Ok") {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }
        setDisableInpunts(!disableInpunts);
        setIsLoadingToSaveMembership(false);

        fetchMembershipInfo();
    }

    const onDelete = async e => {
        e.preventDefault();
        setIsLoadingToSaveMembership(true);

        const response = await fetch(baseUrl + "deleteMembership/" + membershipInfo.id, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
        });

        const json = await response.json();
        if (json.message == "Ok") {
            localStorage.setItem('membershipInfo', '');
            history.goBack();
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }
        setDisableInpunts(!disableInpunts);
        setIsLoadingToSaveMembership(false);
    }

    const handleSwitch = event => {
        setMembershipType({ text: '', valid: null });
        setMembershipValidity('Vigencia');
        setIsOutOfDate(event.target.checked);
    };

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}
            <div className={classes.titleRow}>
                <PageTitle title="Información de la membrecía" />

                {isLoading ? (
                    <></>
                ) : (
                    <>
                        <div className={classes.marginAuto} />
                        <div className={classes.divActionButton} >
                            <Edit classes={{ root: classes.searchIcon }}
                                onClick={() => {
                                    setDisableInpunts(!disableInpunts);
                                }}
                            />
                        </div>
                        <div className={classes.divActionButtonDisable} >
                            <Delete
                                classes={{ root: !disableInpunts ? classes.activeButtonDisable : classes.searchIcon }}
                                onClick={!disableInpunts ? null : onDelete}
                            />
                        </div>
                    </>
                )}
            </div>

            <div className={classes.divCard} >
                {isLoading ? (
                    <CircularProgress size={26} className={classes.loginPage} />
                ) : (
                    <>
                        <div className={classes.divColumn} >
                            <InputComponent
                                text={membershipName}
                                setPartnerCode={setMembershipName}
                                type="text"
                                label="Nombre"
                                name="name"
                                regularExpression={expressions.textNumberAndSymbols}
                                placeholder="Nombre"
                                isEnable={disableInpunts}
                                isRequired={true}
                            />

                            <InputComponent
                                text={description}
                                setPartnerCode={setDescription}
                                type="text"
                                label="Descripción"
                                name="description"
                                regularExpression={expressions.textNumberAndSymbols}
                                placeholder="Descripción corta"
                                isEnable={disableInpunts}
                            />

                            {/*<div>
                                <label className={classes.label} >{"¿Vigencia por días?"}</label>
                                <div className={classes.divSwitch}>
                                    <p style={{ marginRight: "8px", fontSize: "16px", }}>No</p>
                                    <Switch
                                        checked={isOutOfDate}
                                        onChange={handleSwitch}
                                        inputProps={{ "aria-label": "controlled" }}
                                        disabled={disableInpunts}
                                    />
                                    <p style={{ marginLeft: "8px", fontSize: "16px", }}>Si</p>
                                </div>
                            </div>*/}

                            {isOutOfDate ? (
                                <>
                                    <div>
                                        <div className={classes.divLabel}>
                                            <p className={classes.label} >Tipo de membrecía</p>
                                            <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                                        </div>

                                        <FormControl className={classes.formControl}>
                                            <Select
                                                onChange={handleChange}
                                                displayEmpty
                                                disabled={disableInpunts}
                                                value={membershipType.text}
                                                style={{ color: "#FFFFFF" }}
                                            >
                                                <MenuItem value=""> Selecciona </MenuItem>
                                                {allMembershipType.map((option) => (
                                                    <MenuItem value={option.name}>{option.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                    </div>

                                    <InputDisable
                                        value={membershipValidity}
                                        type="text"
                                        label="Vigencia"
                                        name="validity"
                                        placeholder="Vigencia"
                                    />
                                </>
                            ) : (
                                <></>
                            )}

                            <InputDisableSimpleText
                                value={membershipValidity}
                                type="text"
                                label="Número de accesos"
                                name="accessNumber"
                                placeholder="1"
                            />

                            <div className={classes.row}>
                                <div className={classes.divDate}>
                                    <label className={classes.labelDate} >Hora de entrada</label>
                                    <TextField
                                        id="time"
                                        type="time"
                                        defaultValue="00:00"
                                        className={classes.textFieldTime}
                                        value={initTime}
                                        onChange={handleInitTimeChange}
                                        disabled={disableInpunts}
                                        style={{ width: '85%' }}
                                        inputStyle={{ width: '85%' }}
                                    />
                                </div>

                                <div className={classes.divDate}>
                                    <label className={classes.labelDate} >Hora de salida</label>
                                    <TextField
                                        id="time"
                                        type="time"
                                        defaultValue="00:00"
                                        className={classes.textFieldTime}
                                        value={closeTime}
                                        onChange={handleCloseTimeChange}
                                        disabled={disableInpunts}
                                        style={{ width: '85%' }}
                                        inputStyle={{ width: '85%' }}
                                    />
                                </div>
                            </div>

                            <SelectServicesAndDays
                                text={services}
                                setValue={setServices}
                                services={allServices}
                                menuProps={MenuProps}
                                isRequired={true}
                                isEnable={disableInpunts}
                                addValues={valuesFromServicesComponent}
                                key={selectServicesKey}
                                keyTable={keyTable}
                            />

                            <InputDecimal
                                text={servicesCost}
                                setPartnerCode={setServicesCost}
                                type="text"
                                label="Costo"
                                name="price"
                                placeholder="100.00"
                                isEnable={disableInpunts}
                            />

                            <InputSelect
                                text={membershipStatus}
                                setValue={setMembershipStatus}
                                label={"Estatus"}
                                options={allStatus}
                                isEnable={disableInpunts}
                            />

                            <InputDisableSimpleText
                                value={creationDate}
                                type="text"
                                label="Fecha de alta"
                                name="creationDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />

                            <InputDisableSimpleText
                                value={lastUpdateDate}
                                type="text"
                                label="Última modificación"
                                name="lastUpdateDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />
                        </div>
                    </>
                )}

                {disableInpunts ? (
                    <br />
                ) : (
                    <div className={classes.divButton}>
                        {isLoadingToSaveMembership ? (
                            <div className={classes.loginLoader} >
                                <CircularProgress size={26} />
                            </div>
                        ) : (
                            <button
                                className={classes.enableButton}
                                onClick={onSubmit}
                            >Guardar</button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
